import { FC } from 'react';

import { MerchantCurrency } from 'components/MerchantCurrency';

type SummaryItemProps = {
  title?: string;
  amount?: number;
  titleCss?: string;
  amountCss?: string;
  titleToolTip?:JSX.Element;
}

export const SummaryItem: FC<SummaryItemProps> = ({ titleToolTip, title, amount, titleCss, amountCss, children, ...props }) => {
  const showTitle = !!title;
  const showAmount = amount !== undefined;

  return (
    <>
      {showTitle && <dt className={titleCss}>{title} <div>{titleToolTip} </div></dt>}
      {showAmount && <MerchantCurrency {...props} className={amountCss} tagName="dd" amount={amount} />}
      {children}
    </>
);
};
